import { FC } from "react";
import { GeneralSelectInputs } from "models/Client/GeneralSelectInputs";
import { MazakaSelect } from "../MazakaSelect";
import useCapitalize from "../Adress/helpers/useCapitalize";
import { useGetAllContractType } from "./ServerSideStates";

const GeneralAllContractType: FC<GeneralSelectInputs> = (props) => {
 
  const types = useGetAllContractType();
  console.log("typeees", types)
  let { capitalize } = useCapitalize();
  return (
    <>
        <MazakaSelect
              name={props.name}
              xs={props.xs}
              sm={props.sm}
              md={props.md}
              lg={props.lg}
              xl={props.xl}
              loading={types.isLoading || types.isFetching}
              disabled={types.isLoading || types.isFetching || props.disabled}
              className={props.className}
              showSearch={true}
              allowClear={props.allowClear || false}
              filterOption={(input, option: any) =>
                (option.label ?? "").toLowerCase().includes(input.toLowerCase())
              }
              label={props.label}
              options={
                types.data?.data
                  ? types.data?.data.filter((item:any)=>item.id===2002).map((item: any) => {
                      return {
                        key: item.id,
                        value: item.id,
                        label: capitalize(item.name),
                      };
                    })
                  : []
              }
              placeholder={props.placeholder}
              mode={props.mode}
              onChange={props.onChange}
              value={props.value}
              rules={props.rules}
            />
    </>
  );
};

export default GeneralAllContractType;
